import { Avatar, Tag, Rating } from "@pinkyhead/dovekit";
import { pickUserIcon } from "../../common/Icon/utils";
import { TagIcons } from "../TagIcons";
import { useCard } from "./Card.hooks";
import { CardProps } from "./Card.interface";
import { 
  Container, 
  IconContainer, 
  UserContainer, 
  RatingContainer,
} from "./Card.styles";
import { ClaimType } from "../../../types";


export const Card = ({ data }: CardProps) => {
  const { showCardDetails, picture, itemTypeLowerCase } = useCard(data);
  return (
    <Container onClick={showCardDetails}>
      <div className="padding">
        <div className="wrapper">
          {picture
            ?
              <Avatar 
                displayName={data.searchName}
                picture={picture}
                size={70}
                fontSize={32}
              />
            :
              <IconContainer isClaimed={data.extraFilters.isClaimed} isPremium={data.extraFilters.isPremium} isRecommended={data.extraFilters.isRecommended}>
                <img src={pickUserIcon(data.itemType)} alt="User icon" />
              </IconContainer>
          }
          {itemTypeLowerCase !== ClaimType.NFP &&
            <RatingContainer>
              <Rating size={16} value={data.rating} gap={2} />
              <span className="rating">{data.rating.toFixed(1)} stars</span>
              <span className="rating">{data.ratingCount} reviews</span>
            </RatingContainer>
          }
        </div>
      </div>
      {/* <div className="divider"></div> */}
      <div></div>
      <UserContainer className="padding">
        <TagIcons 
          isPremium={data.extraFilters.isPremium}
          isClaimed={data.extraFilters.isClaimed}
          isRecommended={data.extraFilters.isRecommended}
        />
        <h3>{data.searchName}</h3>
        <Tag name={data.speciality} />
        <span className="address">{data.address}</span>
        <span className="distance">{data.distance[0].toFixed(0)} miles away</span>
      </UserContainer>
    </Container>
  )
}
